<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ClassDetail :form-data="data" slot-scope="{data}"></ClassDetail>
  </l-cache>
</template>
<script>
import ClassDetail from './classDetail'
export default {
  name: 'classDetailBox',
  components: {ClassDetail},
  methods: {
    async getItem (key) {
      let pagination = {pages: 1, rowsPerPage: 10}
      let url = '/messageApi/admin/getMsgLabelType'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, search: {key: 'id', value: this.$route.query.id}, url: url})
      if (items.length !== 0) {
        return items[0]
      }
      else {
        this.$L.alert('error', {message: '查询失败，未查到该标签类型'})
      }
    }
  }
}
</script>
